(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["m2-sortiment-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('m2-menu-photos')) {
  customElements.define('m2-menu-photos', class extends HTMLElement {
    connectedCallback() {
      this.menu = this.closest('details');
      this.loadPhotos = () => {
        if (this.menu && !this.menu.open) return;
        this.querySelectorAll('img[data-src]').forEach((photo) => {
          photo.src = photo.dataset.src;
          photo.removeAttribute('data-src');
        });
        this.menu?.removeEventListener('toggle', this.loadPhotos);
      };
      this.menu?.addEventListener('toggle', this.loadPhotos);
      this.loadPhotos();
    }
    disconnectedCallback() {
      this.menu?.removeEventListener('toggle', this.loadPhotos);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
